<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Swal from "sweetalert2";

import {
  DxDataGrid,
  DxColumn,
  DxFilterRow,
  DxPager
} from 'devextreme-vue/data-grid';
import { getBaseUrl } from "@/helpers/baseUrl";

export default {
  components: {
    Layout,
    PageHeader,
    DxButton,
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxToolbar,
    DxItem,
    DxPager,
  },
  data() {
    return {
      title: "Gerenciamento de deparos",
      items: [
        { text: "Monitoramento", href: "/tracking/monitoramento" },
        { text: "Deparos", active: true }
      ],
      dataList: null,
      updating: false,
      showModalEdit: false,
      selectedDeparo: {},
      isEditing: false
    };
  },
  mounted() {
    this.atualizaDataList();
  },
  methods: {
    atualizaDataList() {
      this.dataList = new CustomStore({
        key: 'id',
        load: () => {
          return api.get(`${getBaseUrl()}api/movstatusdeparo`).then(response => {
            return {
              data: response.data.data || response.data,
              totalCount: response.data.totalCount || response.data.length,
            }
          });
        },
        remove: (key) => {
          return api.delete(`${getBaseUrl()}api/movstatusdeparo/${key}`);
        }
      });
    },

    onRowDblClick(e) {
      this.selectedDeparo = { ...e.data };
      this.isEditing = true;
      this.showModalEdit = true;
    },

    novoDeparo() {
      this.selectedDeparo = { status_code: '', status_obsentr: '' };
      this.isEditing = false;
      this.showModalEdit = true;
    },

    async salvarDeparo() {
      try {
        await api.post(`${getBaseUrl()}api/movstatusdeparo`, {deparoData: this.selectedDeparo});
        this.showModalEdit = false;
        this.atualizaDataList();
        Swal.fire("Sucesso", "Deparo salvo com sucesso!", "success");
      } catch (error) {
        Swal.fire("Erro", "Erro ao salvar deparo.", "error");
      }
    },

    async excluirDeparo() {
      const result = await Swal.fire({
        title: 'Tem certeza?',
        text: "Esta ação não pode ser revertida!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, deletar!'
      });

      if (result.isConfirmed) {
        await api.delete(`${getBaseUrl()}api/movstatusdeparo/${this.selectedDeparo.id}`);
        this.showModalEdit = false;
        this.atualizaDataList();
        Swal.fire('Deletado!', 'O registro foi removido.', 'success');
      }
    },

    downloadExemplo() {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Deparos');
      worksheet.columns = [
        { header: 'status_code', key: 'status_code' },
        { header: 'status_obsentr', key: 'status_obsentr' },
      ];
      worksheet.addRow(['Entrega Finalizada', 'status de entrega finalizada']);
      worksheet.addRow(['Ocorrência', 'status de ocorrência']);
      workbook.xlsx.writeBuffer().then(buffer => {
        saveAs(new Blob([buffer]), 'exemplo_deparo.xlsx');
      });
    },

    async uploadExcel(event) {
      const file = event.target.files[0];
      if (!file) return;
      const workbook = new Workbook();
      const buffer = await file.arrayBuffer();
      await workbook.xlsx.load(buffer);
      const worksheet = workbook.getWorksheet(1);
      const jsonData = [];
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) {
          jsonData.push({
            status_code: row.getCell(1).value,
            status_obsentr: row.getCell(2).value,
          });
        }
      });
      try {
        this.selectedDeparo = jsonData
        this.salvarDeparo();
      } catch (e) {
        Swal.fire("Erro", "Falha na importação.", "error");
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <DxToolbar class="mb-3">
      <DxItem
          location="before"
          widget="dxButton">
        <DxButton
          icon="refresh"
          hint="Redefinir formatação de tabela para padrão"
          :on-click="atualizaDataList"/>
      </DxItem>
      <DxItem location="before">
        <DxButton icon="plus" text="Novo Deparo" type="default" @click="novoDeparo" />
      </DxItem>
      <DxItem location="before">
        <DxButton icon="download" text="Baixar Exemplo" @click="downloadExemplo" />
      </DxItem>
      <DxItem location="before">
        <div class="btn btn-outline-success btn-sm position-relative overflow-hidden p-2 d-flex gap-2">
          <i class="bx bx-upload font-size-15"></i> Importar Excel
          <input type="file" class="position-absolute start-0 top-0 opacity-0" @change="uploadExcel" accept=".xlsx" />
        </div>
      </DxItem>
    </DxToolbar>

    <DxDataGrid
      :data-source="dataList"
      :show-borders="true"
      :column-auto-width="true"
      @row-dbl-click="onRowDblClick"
    >
      <DxFilterRow :visible="true" />
      <DxColumn data-field="id" caption="ID" />
      <DxColumn data-field="status_code" caption="Status Code" />
      <DxColumn data-field="status_obsentr" caption="Observação Entrada" />
      <DxPager :visible="true" :show-page-size-selector="true" :allowed-page-sizes="[10, 20, 50]" />
    </DxDataGrid>

    <b-modal v-model="showModalEdit" :title="isEditing ? 'Editar Deparo' : 'Novo Deparo'" centered hide-footer>
      <div class="mb-3">
        <label>Status Code</label>
        <!-- <input v-model="selectedDeparo.status_code" class="form-control" /> -->
         <select v-model="selectedDeparo.status_code" class="form-control">
          <option value="">Selecione um status</option>
          <option value="Entrega Finalizada">EFN - Entrega Finalizada</option>
          <option value="Ocorrência">OCC - Ocorrência</option>
        </select>
      </div>
      <div class="mb-3">
        <label>Observação Entrada</label>
        <input v-model="selectedDeparo.status_obsentr" class="form-control" />
      </div>
      <div class="d-flex justify-content-between mt-4">
        <b-button v-if="isEditing" variant="danger" @click="excluirDeparo">Excluir</b-button>
        <div>
          <b-button variant="light" @click="showModalEdit = false" class="me-2">Cancelar</b-button>
          <b-button variant="success" @click="salvarDeparo">Salvar</b-button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
